import { combineReducers } from 'redux';

import AuthReducer from './AuthReducer';
import ScheduleReducer from './ScheduleReducer';

import PostReducer from './PostReducer';

import LibraryReducer from "./LibraryReducer";
import JourneyReducer from './JourneyReducer';
import TagReducer from "./TagReducer";

import DrawerReducer from "./DrawerReducer";
import UserReducer from "./UserReducer";

export default combineReducers({
    auth: AuthReducer,
    user: UserReducer,

    post: PostReducer,

    journey: JourneyReducer,

    drawer: DrawerReducer,
})
